import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { motion } from "framer-motion";
import SendIcon from "@mui/icons-material/Send";

// Imagen reutilizada (reemplaza la ruta por la correcta)
import imgForm from "../../static/media/contacto/tecnicos.webp";

const C = {
  darkBlue: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  gray: "#F5F7FA",
  white: "#ffffff",
  footerColor: "#c2ed80", // Color del footer para la transición
};

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    background: C.gray,
    "&.Mui-focused fieldset": { borderColor: C.navy, borderWidth: "2px" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: C.navy, fontWeight: 700 },
};

export default function ContactoForm() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("¡Gracias por tu mensaje! Nos pondremos en contacto pronto.");
  };

  return (
    <Box
      id="contacto-form"
      sx={{
        background: C.white,
        pt: { xs: "80px", md: "100px" },
        pb: { xs: "25vw", md: "12vw" }, // Espacio para la curva SVG inferior
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: 3, sm: 5, md: 6 },
          zIndex: 1,
          position: "relative",
        }}
      >
        {/* TÍTULO CENTRADO CON LÍNEA Y SUBTÍTULO */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{
            mb: { xs: 6, md: 10 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.darkBlue,
              fontWeight: 750,
              fontSize: { xs: 28, sm: 34, md: 40 },
              letterSpacing: "-.02em",
              lineHeight: 1.1,
              mb: 2,
            }}
          >
            Envíanos un mensaje
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "3px",
              background: C.gold,
              borderRadius: "2px",
              mb: 3,
            }}
          />
          <Typography
            sx={{
              color: "#5c6c7a",
              fontSize: { xs: 14, md: 16 },
              maxWidth: "600px",
              lineHeight: 1.6,
            }}
          >
            Déjanos tu consulta y nuestro equipo de expertos te responderá a la
            brevedad posible.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "center",
            gap: { xs: 6, md: 8 },
          }}
        >
          {/* LADO IZQUIERDO (Imagen, en móvil va primero) */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            sx={{
              width: { xs: "100%", lg: "50%" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              component={motion.img}
              src={imgForm}
              alt="Atención al cliente"
              animate={{ y: [-8, 8, -8] }} // Animación de flotación
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1,
              }}
              sx={{
                width: "100%",
                height: "auto",
                maxHeight: "500px",
                objectFit: "cover",
                borderRadius: "24px",
                boxShadow: "0 15px 35px rgba(12, 31, 47, 0.15)",
              }}
            />
          </Box>

          {/* LADO DERECHO (Formulario, en móvil va después de la imagen) */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            sx={{ width: { xs: "100%", lg: "50%" } }}
          >
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3.5,
                background: C.white,
                p: { xs: 0, md: 4 },
                borderRadius: "24px",
              }}
            >
              <TextField
                label="Nombre completo"
                variant="outlined"
                fullWidth
                required
                sx={fieldSx}
              />
              <TextField
                label="Correo electrónico"
                type="email"
                variant="outlined"
                fullWidth
                required
                sx={fieldSx}
              />
              <TextField
                label="Mensaje o consulta"
                variant="outlined"
                fullWidth
                required
                multiline
                rows={5}
                sx={fieldSx}
              />

              <Button
                type="submit"
                variant="contained"
                endIcon={<SendIcon />}
                sx={{
                  background: C.gold,
                  color: C.darkBlue,
                  fontWeight: 700,
                  fontSize: { xs: 14, md: 16 },
                  py: 1.8,
                  borderRadius: "50px",
                  textTransform: "none",
                  boxShadow: "0 10px 25px rgba(255,205,0,0.3)",
                  mt: 1,
                  alignSelf: { xs: "stretch", sm: "flex-start" },
                  px: { xs: 4, sm: 6 },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: C.goldDark,
                    transform: "translateY(-4px)",
                    boxShadow: "0 15px 30px rgba(255,205,0,0.4)",
                  },
                }}
              >
                Enviar Mensaje
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
